<template>
  <div class="aui-content">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  >
         <ul class="aui-list aui-media-list maui-bidding-list"  v-for="(item,i) in comments" :key="i">
          <div  @click="getNews(item.id,i)">
        <!-- <li v-if="true" class="itemStyle" ><img src="{{item.pictureUrl}}"></li> 
        <router-link to='/gyxx'><button>提交</button></router-link>-->
				<!-- <div class="aui-list-item-media" style=" height:200px" >
					 <img src="../assets/img.jpg"> 
				</div> -->
				<div class="aui-list-item-inner" style=" padding: 0.7rem 5rem 0.75rem 0.4rem;">
					<div class="aui-list-item-text">
						<div class="aui-list-item-title">{{item.title}}</div>
					</div>
					<div class="maui-list-item">
						<!-- <div class="aui-label maui-label-green">{{item.goodsClassName}}</div>
						<div class="aui-label maui-label-green">{{item.number}}吨</div> -->
						<div class="aui-label maui-label-gray">{{item.createDate | datefmt('YYYY-MM-DD')}}</div>
					</div>
				</div>
         <!-- <router-link to='/supply'></router-link> -->
			</div>
        </ul> 
         </van-list>
  </div>
</template>
 
<script>
  export default {
    name: "ScrollerOne",
    data() {
      return {
        //noDate: false,//这是一个判断是否加载的开关
        arr: [],
        showPage: 1,
        pageSize: 4,
        comments: [],
       pageindex: 1,
      loading: false,
      totalElements:'',
      finished: false,
      }
    },
    // created() {
    //    this.getComments();
    // },
    methods: {
      onLoad() {
          this.$axios
        .get('/micro/permission_order-view/article/read/query?pageNo='+ this.pageindex+'&pageSize=&sort=0&categoryPath=512098260ccb4a7a865ae415e907a236&kyeWord')
        .then(res => {
            // this.comments = result.body.message;
            // 不替换老数据
            this.comments = this.comments.concat(res.data.data.articleList)
             this.totalElements=res.data.data.totalElements
        });
      // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore()
        // 加载状态结束
        this.loading = false;
        if (this.comments.length >=this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },
// onRefresh() {
//       setTimeout(() => {
//         this.$toast('刷新成功');
//         this.isLoading = false;
//         this.count++;
//       }, 500);
//     },
 getMore() {
   this.pageindex++;
    },
      getNews(item,i) {
         console.log(item)
            this.$router.push({path: '/article1form',query:{xqid:item}});
        }
    },
 
  }
</script>
 
<style scoped>
 .container {
    display: flex;
    width: 375px;
    height: 100%;
    /* background: red; */
    flex-direction: column;
  }
 
  .itemStyle {
    display: flex;
    width: 375px;
    height: 100px;
    /* background: coral;
    border: 1px blue solid; */
    margin-bottom: 5px;
  }
  .van-list__finished-text{
 text-align:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/article1.vue